import React, { createContext, useState, useEffect, useContext, useMemo } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check system preference on initial load
    if (window.matchMedia) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return true; // Default to dark mode
  });

  useEffect(() => {
    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      setIsDarkMode(e.matches);
    };

    // Modern browsers
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    } 
    // Fallback for older browsers
    else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }
  }, []);

  // Centralized theme variables
  const theme = useMemo(() => ({
    isDarkMode,
    colors: {
      bg: isDarkMode ? 'bg-black' : 'bg-white',
      text: isDarkMode ? 'text-white' : 'text-black',
      border: isDarkMode ? 'border-white' : 'border-black',
      hoverBg: isDarkMode ? 'hover:bg-white' : 'hover:bg-black',
      hoverText: isDarkMode ? 'hover:text-black' : 'hover:text-white',
      headerBg: isDarkMode ? 'bg-black/80' : 'bg-white/80',
      mobileMenuBg: isDarkMode ? 'bg-black' : 'bg-white',
      borderOpacity: isDarkMode ? 'border-white/20' : 'border-black/20',
      textOpacity: isDarkMode ? 'text-white/70' : 'text-black/70',
      textOpacity90: isDarkMode ? 'text-white/90' : 'text-black/90',
      icon: isDarkMode ? 'text-white' : 'text-black',
    },
    button: {
      base: `header-button font-mono text-sm ${isDarkMode ? 'header-button-dark' : ''}`,
      mobile: `header-button font-mono text-sm ${isDarkMode ? 'header-button-dark' : ''}`
    }
  }), [isDarkMode]);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

